import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings as SettingsIcon, Wrench, Clock, AlertTriangle, FileText, ChevronRight } from 'lucide-react';

const Settings = () => {
  const navigate = useNavigate();

  const handleTestConfigurationsClick = () => {
    navigate('/test-configurations');
  };

  return (
    <div>
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold azure-text">Settings</h1>
            <p className="mt-2 text-blue-700 font-medium">
              Configure system settings and preferences
            </p>
          </div>
        </div>
      </div>

      {/* Available Settings */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {/* Test Configurations */}
        <div
          className="card hover:shadow-lg transition-shadow duration-200 cursor-pointer"
          onClick={handleTestConfigurationsClick}
        >
          <div className="flex items-center justify-between p-6">
            <div className="flex items-center space-x-4">
              <div className="h-12 w-12 bg-gradient-to-r from-blue-100 to-sky-100 rounded-lg flex items-center justify-center">
                <FileText className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold azure-text">Test Configurations</h3>
                <p className="text-sm text-blue-600">Manage exam patterns and settings</p>
              </div>
            </div>
            <ChevronRight className="h-5 w-5 text-blue-400" />
          </div>
        </div>
      </div>

      {/* Additional Settings - Coming Soon */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* System Configuration - Coming Soon */}
        <div className="card opacity-60">
          <div className="flex items-center justify-between p-6">
            <div className="flex items-center space-x-4">
              <div className="h-12 w-12 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
                <SettingsIcon className="h-6 w-6 text-gray-500" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-600">System Configuration</h3>
                <p className="text-sm text-gray-500">Global system settings</p>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <Clock className="h-4 w-4" />
              <span className="text-xs">Coming Soon</span>
            </div>
          </div>
        </div>

        {/* Email Templates - Coming Soon */}
        <div className="card opacity-60">
          <div className="flex items-center justify-between p-6">
            <div className="flex items-center space-x-4">
              <div className="h-12 w-12 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
                <Wrench className="h-6 w-6 text-gray-500" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-600">Email Templates</h3>
                <p className="text-sm text-gray-500">Customize email notifications</p>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <Clock className="h-4 w-4" />
              <span className="text-xs">Coming Soon</span>
            </div>
          </div>
        </div>

        {/* Security Settings - Coming Soon */}
        <div className="card opacity-60">
          <div className="flex items-center justify-between p-6">
            <div className="flex items-center space-x-4">
              <div className="h-12 w-12 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
                <AlertTriangle className="h-6 w-6 text-gray-500" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-600">Security Settings</h3>
                <p className="text-sm text-gray-500">Authentication & access control</p>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <Clock className="h-4 w-4" />
              <span className="text-xs">Coming Soon</span>
            </div>
          </div>
        </div>
      </div>

      {/* Help Section */}
      <div className="card mt-8">
        <div className="p-6">
          <h3 className="text-lg font-semibold azure-text mb-4">Need Help?</h3>
          <p className="text-blue-700 mb-4">
            For immediate assistance with system configuration or any questions, please contact our support team.
          </p>
          <a
            href="mailto:support@bayesprep.com"
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default Settings;
